import { Injectable } from '@angular/core';

// Services
import { ServiceBase } from '../service-base';

const CLASS_NAME = 'PartnerContact';
const ENDPOINT = `/partner-contacts/`;

@Injectable({
    providedIn: 'root'
})
export class PartnerContactService extends ServiceBase {
    constructor() {
        super(CLASS_NAME, ENDPOINT);
    }
}
